
export function displayValOrNc(val) {

    return val ? val : "NC";
}

export function getTypeLabel(typeCode) {

    switch (typeCode) {
        case "MP":
            return "Membre Participant";
        case "CJT":
            return "Conjoint";
        case "ENF":
            return "Enfant";
        case "ENFHAN":
            return "Enfant handicapé";
            case "AUT":
            return "Enfant";
        case "ASC":
            return "Ascendant";

    }
}

export function getLabelInput(inutConf, notMandatory = false) {


    return `${ inutConf?.LABEL }${ inutConf?.MANDATORY && !notMandatory ? " *" : "" } ${ inutConf?.IS_QUESTION ? " ?" : " :" }`
}

export function getDigit(string) {

    return string.match(/\d+/g)
}